import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8zb3ehhn27: FaireBrandEntity = {
  token: "b_8zb3ehhn27",
  type: "brand",
  name: "ohimgood",
  avatarUrl:
    "https://cdn.faire.com/fastly/135ce22af17f7cbffcca56e2ce76cf44d34c467608b8d8d03e44519f7d737772.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ef8a7d45092101f287d403403daa639fb1f6012e4dea8977111d1eff135c1349.png",
  logoUrl:
    "https://cdn.faire.com/fastly/135ce22af17f7cbffcca56e2ce76cf44d34c467608b8d8d03e44519f7d737772.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ef8a7d45092101f287d403403daa639fb1f6012e4dea8977111d1eff135c1349.png",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Jesley Lau is a Hong Kong illustrator based in Toronto. As a self-taught artist, she embraces a boundless approach to illustration, expressing her thoughts with refreshing simplicity and directness. Through ohimgood, she aims to bring comfort, courage, and a touch of chill to a world that can sometimes feel overwhelming. Her work often explores themes of love, relationships, nature, animals, and the everyday moments that make life beautiful, offering viewers a touch of joy and a reminder of life's endless possibilities.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:47.665Z",
    importedBy: "entity-db-cli",
  },
};
